export default __webpack_public_path__ + "static/media/heart.528b5352.svg";